import React, { FC, memo } from 'react';
import Link from '../../CustomNextLink';
import { getValidUrl } from '@utils/url.utils';

export interface IDestination {
    type: 'href' | 'link';
    to: string;
}

interface IProps {
    destination: IDestination;
    title?: string;
    id?: string;
}

const HeaderLink: FC<IProps> = ({ id, destination, title }) =>
    destination.type === 'href' ? (
        <a href={getValidUrl(destination.to)}>{title}</a>
    ) : (
        <Link href={destination.to}>
            <a id={id}>{title}</a>
        </Link>
    );

export default memo(HeaderLink);
